module.exports = __webpack_public_path__ + "img/nftinfoCopy.398c082a.svg";